
import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export type SortOption = {
  value: string;
  label: string;
};

interface SortingFilterProps {
  onSortChange: (value: string) => void;
  defaultValue?: string;
}

export const SortingFilter = ({ onSortChange, defaultValue = "latest" }: SortingFilterProps) => {
  const [selectedSort, setSelectedSort] = useState(defaultValue);

  const sortOptions: SortOption[] = [
    { value: "latest", label: "Newest First" },
    { value: "oldest", label: "Oldest First" },
    { value: "price_high", label: "Price: High to Low" },
    { value: "price_low", label: "Price: Low to High" },
    { value: "name_asc", label: "Name: A to Z" },
    { value: "name_desc", label: "Name: Z to A" },
  ];

  const handleSortChange = (value: string) => {
    setSelectedSort(value);
    onSortChange(value);
  };

  return (
    <div className="flex items-center">
      <label htmlFor="sort-select" className="mr-2 text-sm font-medium">Sort by:</label>
      <Select onValueChange={handleSortChange} defaultValue={selectedSort}>
        <SelectTrigger id="sort-select" className="w-[180px] h-9 text-sm">
          <SelectValue placeholder="Select sort option" />
        </SelectTrigger>
        <SelectContent>
          {sortOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SortingFilter;
